import '../../../../scss/feature.scss';
import '../../../../scss/critical.scss';

import Vue from 'vue';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { getPiniaInstance } from "../../../lib-sat/store/page-store";
import router from "../../../qaamgo/modules/sat/components/aicreatorstudio/router";
import AiCreatorStudio from "../../../qaamgo/modules/sat/components/aicreatorstudio/AiCreatorStudio.vue";
import TransFilter from '../../../qaamgo/modules/sat/components/mixins/TransFilter.vue';
import 'blueimp-file-upload';

const $ = require('jquery');
global.$ = global.jQuery = $;

import(
    /* webpackMode: "eager" */
    '../../qg-main'
).then(function () {
    import(
        /* webpackMode: "lazy-once" */
        `./../../translations/sat/${sat.locale}.js`
        ).then(function () {
    import(
        /* webpackMode: "lazy" */
        '../../../lib-sat/uploader/qg-uploader-functions'
    ).then(async function () {});

    const pinia = getPiniaInstance();
    pinia.use(piniaPluginPersistedstate);
    
    Vue.mixin(TransFilter);
    Vue.filter('truncate', (value, length, clamp) => {
        if (value.length <= length) {
            return value;
        } else {
            return value.slice(0, length) + clamp;
        }
    });

    let cStudio = new Vue({
        el: '#AiArtStudio',
        name: 'AiCreatorStudio',
        components: { AiCreatorStudio },
        pinia,
        router,
        render(h) {
            return h(AiCreatorStudio);
        },
    });

    });
});
